import { HStack, IconProps, Text } from "@chakra-ui/react";
import React from "react";

import {
  GH_RATING_DEFINITELY_NOT,
  GH_RATING_NO,
  GH_RATING_NO_DECISION,
  GH_RATING_STRONG_YES,
  GH_RATING_YES,
  GreenhouseRatingSummaryItem,
} from "../../utils/greenhouse"; // Import constants
import {
  GreenhouseMixedIcon,
  GreenhouseNoIcon,
  GreenhouseStrongNoIcon,
  GreenhouseStrongYesIcon,
  GreenhouseYesIcon,
} from "../Icons/GreenhouseIcons";

const ratingToIconMap: Record<string, React.FC<IconProps>> = {
  [GH_RATING_STRONG_YES]: GreenhouseStrongYesIcon,
  [GH_RATING_YES]: GreenhouseYesIcon,
  [GH_RATING_NO_DECISION]: GreenhouseMixedIcon,
  [GH_RATING_NO]: GreenhouseNoIcon,
  [GH_RATING_DEFINITELY_NOT]: GreenhouseStrongNoIcon,
};

interface GreenhouseRatingsDisplayProps {
  ratings: GreenhouseRatingSummaryItem[] | null;
}

export const GreenhouseRatingsDisplay: React.FC<
  GreenhouseRatingsDisplayProps
> = ({ ratings }) => {
  if (!ratings || ratings.length === 0) {
    return null; // Don't render anything if there are no ratings
  }

  // Define the desired order for display
  const ratingOrder = [
    GH_RATING_DEFINITELY_NOT,
    GH_RATING_NO,
    GH_RATING_NO_DECISION,
    GH_RATING_YES,
    GH_RATING_STRONG_YES,
  ];

  // Sort the input ratings based on the desired order
  const sortedRatings = [...ratings].sort((a, b) => {
    const indexA = ratingOrder.indexOf(a.ratingKey);
    const indexB = ratingOrder.indexOf(b.ratingKey);
    // Handle cases where a rating might not be in the order (though summarizeGreenhouseRatings should handle this)
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  return (
    <HStack spacing="3">
      {sortedRatings.map(({ ratingKey, count }) => {
        const IconComponent = ratingToIconMap[ratingKey];
        if (!IconComponent) {
          // Optionally handle unknown rating keys if they can occur
          return null;
        }
        return (
          <HStack key={ratingKey} spacing="0.5" alignItems="center">
            <IconComponent boxSize="20px" color="gray.600" />
            <Text fontSize="xs" fontWeight="medium">
              {count || "0"}
            </Text>
          </HStack>
        );
      })}
    </HStack>
  );
};
